<div class="unsub-container">
    <div class="illustraioncardwrapper">
        <div class="ng-container">
            <div class="card nb-card boxShadow">
                <div class="card-header">
                    <div class="icon-wrapper ">
                        <img src="assets/images/icons/right-tick.svg" alt="Apply for your loan online"
                            class="card-icon" />
                    </div>

                </div>
                <div class="card-body border-top-0">
                    <h4>You have been successfully unsubscribed.</h4>
                    <p></p>


                </div>
            </div>
        </div>
    </div>
</div>